(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-lh-search]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const arrival = form.elements.arrival, departure = form.elements.departure;
      const today = new Date();
      const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0,10);
      arrival.min = localDate; departure.min = localDate;
      const dialog = form.closest('section').querySelector('[data-lh-results]');
      dialog.querySelector('[data-lh-close]').addEventListener('click',()=>dialog.close());
      const update = () => {
        departure.min = arrival.value || localDate;
        departure.setCustomValidity(arrival.value && departure.value && departure.value <= arrival.value ? 'Le départ doit suivre la date d’arrivée.' : '');
        const display = v => v ? new Date(v + 'T12:00:00').toLocaleDateString('fr-FR', {day:'numeric', month:'short'}) : '';
        form.querySelector('[data-date-label]').textContent = [display(arrival.value)||'Arrivée',display(departure.value)||'Départ'].join(' → ');
      };
      arrival.addEventListener('change',update);departure.addEventListener('change',update);
      form.addEventListener('submit', event => {
        event.preventDefault();update();if (!form.reportValidity()) return;
        const destination = form.elements.destination.value;
        const target = new URL(destination || form.action, location.origin);
        target.searchParams.set('voyageurs',form.elements.guests.value);
        if(arrival.value) target.searchParams.set('arrivee',arrival.value);
        if(departure.value) target.searchParams.set('depart',departure.value);
        const dialog = form.closest('section').querySelector('[data-lh-results]');
        const guests = Number(form.elements.guests.value);
        const seen = new Set(); let count = 0;
        dialog.querySelectorAll('[data-lh-property]').forEach(card => {
          const capacity = Number(card.dataset.capacity);
          const match = (!destination || card.dataset.destination === destination) && (!capacity || capacity >= guests) && !seen.has(card.getAttribute('href'));
          card.hidden = !match;
          if(match){seen.add(card.getAttribute('href'));count++;}
        });
        dialog.querySelector('[data-lh-summary]').textContent = guests + (guests > 1 ? ' voyageurs' : ' voyageur') + (arrival.value || departure.value ? ' · ' + form.querySelector('[data-date-label]').textContent : '');
        dialog.querySelector('[data-lh-empty]').hidden = count > 0;
        dialog.showModal();
      });
    });
  };
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
